// extracted by mini-css-extract-plugin
export var noSpinners = "_om-6";
export var percentageInput = "_om-7";
export var variantColor1 = "_om-0";
export var variantColor2 = "_om-1";
export var variantColor3 = "_om-2";
export var variantColor4 = "_om-3";
export var variantColor5 = "_om-4";
export var variantColor6 = "_om-5";